import { PureComponent } from "react";
import { StyledCardComponent } from "./card-component.scss";
import colors from "/styles/colors";

export default class CardComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { height, width, children, background } = this.props;
    const style = {
      height: height,
      width: width,
      backgroundColor: colors[background]
    };

    return (
      <StyledCardComponent className="card-component" style={style}>
        {children}
      </StyledCardComponent>
    );
  }
}
